import styled from 'styled-components';

export const ZoomButton = styled.div`

  border: 2px solid;
  border-color: ${(props) => props.theme.buttons};
  display: inline-block;
  border-radius: 20px;
  padding: 12px 8px;

  button {
    display: block;
    background-color: transparent;
    border: none;
    margin: 0 auto;
    cursor: pointer;
  }

  .divider {
    content: '';
    display: block;
    background-color: ${(props) => props.theme.divider};
    height: 2px;
    width: 80%;
    margin: 10px auto;
    box-sizing: border-box;
  }
`;
